import { clientFetch } from '../clientFetch';

export const getConditionKeyword = async (projectId) => clientFetch(`/entity/conditions/keyword/${projectId}`);
